/**
 * Reusable installation instructions shown after downloading.
 */
export function InstallationInstructions({ className }: { className?: string }) {
  return (
    <div className={className}>
      <p className="text-xs font-semibold text-gray-900 dark:text-gray-100 mb-2">
        Instrucciones de instalación
      </p>
      <ol className="space-y-1.5 text-[11px] text-gray-600 dark:text-gray-400 list-decimal list-inside">
        <li>Descarga el ZIP con los archivos de la instalación</li>
        <li>Transfiere los archivos al servidor de destino</li>
        <li>
          Descomprime:{" "}
          <code className="bg-gray-100 dark:bg-gray-700 px-1 rounded font-mono">
            unzip instalacion.zip
          </code>
        </li>
        <li>
          DICOM:{" "}
          <code className="bg-gray-100 dark:bg-gray-700 px-1 rounded font-mono">
            cd servicios-dicom && chmod +x ./install.sh && ./install.sh
          </code>
          {" "}(Caddy + servicios del paquete). Acceso directo:{" "}
          <code className="bg-gray-100 dark:bg-gray-700 px-1 rounded font-mono">
            ./install.sh --no-caddy
          </code>
        </li>
        <li>
          HIS / RIS / bridge:{" "}
          <code className="bg-gray-100 dark:bg-gray-700 px-1 rounded font-mono">
            chmod +x ./install.sh && ./install.sh
          </code>
          {" "}dentro de cada carpeta.
        </li>
        <li>Para soporte, contacta al equipo de desarrollo</li>
      </ol>
    </div>
  );
}
